module.exports = __webpack_public_path__ + "static/media/users.ca71143f.svg";